import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <RankingSection />
        <ContactSection />
        <FAQSection />
        <CardsSection />
        <TopicsSection />
        <IndexSection />
        <FeaturesSection />
        <AppSection />
        <UpdatesSection />
        <AboutSection />
        <CommentsSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}